module.exports = __webpack_public_path__ + "media/images/black_apple_store-e0f55e0e1701ec1bb9d8436b5f45e542.png";